import $ from 'cash-dom';

export default () => {
  const $menu = $('.js-scroll-menu');

  if ($menu.length) {
    const headerHeight = $('.header').height();
    const menuHeight = $menu.height();
    const $items = $menu.find('.scroll-menu__link');

    const controlActivity = () => {
      $items.each((i, el) => {
        const $this = $(el);
        const $section = $($this.attr('href'));
        const sectionOffsetTop = $section.offset().top;
        const sectionHeight = $section.outerHeight();
        const sectionDistance = sectionOffsetTop + sectionHeight;
        const scrollTop = window.pageYOffset + headerHeight + menuHeight;

        if (scrollTop >= sectionOffsetTop && scrollTop < sectionDistance) {
          $this.addClass('is-active');
        } else {
          $this.removeClass('is-active');
        }
      });
    };

    controlActivity();

    $(window).on('scroll', () => {
      controlActivity();
    });
  }
};
